import GoogleMapsLoader from 'google-maps';

let mapsApi;
let autocompleteService;
let placesService;

function initMapsApi() {
  return new Promise((resolve) => {
    if (mapsApi) {
      resolve(mapsApi);
    } else {
      GoogleMapsLoader.load((google) => {
        mapsApi = google.maps;
        resolve(mapsApi);
      });
    }
  });
}

function initiAutocompleteService() {
  return new Promise((resolve) => {
    if (autocompleteService) {
      resolve(autocompleteService);
    } else {
      initMapsApi().then((api) => {
        autocompleteService = new api.places.AutocompleteService();
        resolve(autocompleteService);
      });
    }
  });
}

function initPlacesService() {
  return new Promise((resolve) => {
    if (placesService) {
      resolve(placesService);
    } else {
      initMapsApi().then((api) => {
        placesService = new api.places.PlacesService(document.createElement('div'));
        resolve(placesService);
      });
    }
  });
}

export default {
  configLoader(conf) {
    Object.assign(GoogleMapsLoader, conf);
  },

  getMapsApi: initMapsApi,

  getPlacePredictions(address, country) {
    const request = { input: address, types: ['geocode'], componentRestrictions: { country } };

    return initiAutocompleteService().then(() => new Promise((resolve, reject) => {
      autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status === mapsApi.places.PlacesServiceStatus.OK) {
          resolve(predictions);
        } else {
          reject(status);
        }
      });
    }));
  },

  getPlaceDetails(placeId) {
    return initPlacesService().then(() => new Promise((resolve, reject) => {
      placesService.getDetails({ placeId }, (place, status) => {
        if (status === mapsApi.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(status);
        }
      });
    }));
  },
};
